module.exports = __webpack_public_path__ + "static/media/vw.1823e443.png";